import { Route, Routes } from 'react-router';
import NotFoundPage from 'src/components/commons/notFound';
import { PageSubTableOpportunities } from '../../pages';

const SubTableOpportunitiesRoutes = () => (
  <Routes>
    <Route element={<PageSubTableOpportunities />}>
      <Route index path='type' element={<h2>Opportunities type</h2>} />
      <Route path='*' element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default SubTableOpportunitiesRoutes;
